import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Anchor } from 'antd';
import { CAMPAIGN_PAGE_ANCHOR_KEY, CAMPAIGN_PREVIEW_ANCHOR_KEY, CampaignType, } from 'config/CustomEnums';
import './AnchorPage.scss';
import { getShowDisplayInFrontend } from 'models/CreateCampaignModel';
import {
  getContentPageAnchor,
  getEarningRuleAnchor,
  getCouponCampaignRulePageAnchor,
  getCouponPageAnchor,
  handleClick,
  AnchorSubTitle,
} from './AnchorPage';

const { Link } = Anchor;

const DetailAnchorPage = ({
  detailData,
  stepWithCoupon,
}) => {
  const dispatch = useDispatch();
  const campaign = detailData || {};

  const {
    campaignType,
    earningRuleType,
    displayInFrontend,
  } = campaign;
  const showDisplayInFrontend = getShowDisplayInFrontend(campaignType, earningRuleType);
  const hideInFrontend = showDisplayInFrontend && !displayInFrontend && showDisplayInFrontend !== undefined;

  const contentPageAnchor = getContentPageAnchor(hideInFrontend, campaign.campaignType);
  const isEarningCampaign = campaign.campaignType === CampaignType.earningRulesCampaign;
  const isCouponCampaign = campaign.campaignType === CampaignType.couponsCampaign;
  const earningRuleAnchor = getEarningRuleAnchor(campaign.linkedEarningRules?.type);
  const couponPageAnchor = getCouponPageAnchor();
  const couponCampaignShowLimit = isCouponCampaign && campaign?.showCouponLimit
  const couponCampaignRulePageAnchor = getCouponCampaignRulePageAnchor(couponCampaignShowLimit);
  return (
    <div className='anchor-page-container'>
      <div className='anchor-page-navigation-container'>
        <label className="create-section-title anchor-page-title">
          NAVIGATION
        </label>
      </div>

      <Anchor
        offsetTop={90}
        onClick={(e, link) => handleClick(e, link, dispatch)}
      >
        <Link className='anchor-title' href={`#${CAMPAIGN_PAGE_ANCHOR_KEY.contentPage}`} title="Content" >
          {
            contentPageAnchor.map(item => (
              <AnchorSubTitle item={item} errorSectionList={[]} />
            ))
          }
        </Link>
        {
          isEarningCampaign && (
            <Link className='anchor-title' href={`#${CAMPAIGN_PAGE_ANCHOR_KEY.earningRulePage}`} title="Rule & Properties" >
              {
                earningRuleAnchor.map(item => (
                  <AnchorSubTitle item={item} errorSectionList={[]} />
                ))
              }
            </Link>
          )
        }
        {
          isCouponCampaign && (
            <Link className='anchor-title' href={`#${CAMPAIGN_PAGE_ANCHOR_KEY.earningRulePage}`} title="Rule & Properties" >
              {
                couponCampaignRulePageAnchor.map(item => (
                  <AnchorSubTitle item={item} errorSectionList={[]} />
                ))
              }
            </Link>
          )
        }
        {stepWithCoupon && <Link className='anchor-title' href={`#${CAMPAIGN_PAGE_ANCHOR_KEY.couponPage}`} title="Coupon set" >
          {
            couponPageAnchor.map(item => (
              <AnchorSubTitle item={item} errorSectionList={[]} />
            ))
          }
        </Link>}
        {!stepWithCoupon && isCouponCampaign && <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_ANCHOR_KEY.checklist}`} title="Check list" />}
      </Anchor>
    </div>
  );
};

const mapStateToProps = (state) => ({
  stepWithCoupon: state.campaignStreamline.stepWithCoupon,
})

export default connect(mapStateToProps)(DetailAnchorPage);
